import React, { Component } from "react";

class Form extends Component {
	constructor(props) {
		super(props);
	}

	handleChange = event => {
		if (this.props.onChange) {
			this.props.onChange(event);
		}
	};

	handleSubmit = event => {
		event.preventDefault();

		const EMAIL_PATTERN = '^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$';
    const EMAIL_REGEXP = new RegExp(EMAIL_PATTERN, 'i');

		let formElements = event.target.elements;
		let anElementHasFocus = false;
		let formData = {
			errors: {},
			isValid: true,
			dataInputed: {}
		};

		for (let x = 0; x < formElements.length; x++) {
			if (!formElements[x].validity.valid || (formElements[x].type === 'email' && !EMAIL_REGEXP.test(formElements[x].value))) {
				if (!anElementHasFocus) {
					formElements[x].focus();
					anElementHasFocus = true;
				}
				if (document.getElementById(`${formElements[x].name}-label`)) {
					document
						.getElementById(`${formElements[x].name}-label`)
						.classList.add("input-component--invalid-input-label");
				}
			
				if (formElements[x].validity.typeMismatch || (formElements[x].type === 'email' && !EMAIL_REGEXP.test(formElements[x].value))) {
					formData.errors[`${formElements[x].name}`] = "typeMismatch";
				} else if (formElements[x].validity.valueMissing) {
					formData.errors[`${formElements[x].name}`] = "valueMissing";
				}
			}
		}

		document.getElementById(event.target.id).classList.add("submitted-form");
		formData.isValid = Object.keys(formData.errors).length <= 0;

		return this.props.submit(formData);
	};

	handleReset = event => {
		return this.props.onReset(event);
	};

	render() {
		const { noValidate, id, className } = this.props;

		return (
			<form
				onSubmit={event => this.handleSubmit(event)}
				noValidate
				id={id}
				onChange={event => this.handleChange(event)}
				onReset={this.handleReset}
				className={className}
			>
				{this.props.children}
			</form>
		);
	}
}

export default Form;
